import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { CardBody, Col, Row } from "reactstrap";
import userImage6 from "../../assets/images/avatar.png";
import AddToBookmarkCandidate from "../../helpers/Common/AddToBookmarkCandidate";
import {
  getJobLocationById,
  getSalaryAmount,
  getTimeAgo,
  getWorkExpText,
  imageUrl,
  isUserActive,
  toArray,
} from "../../helpers/common";

const CandidateRow = ({ details }) => {
  const additionalFields = details?.additional_fields
    ? JSON.parse(details.additional_fields)
    : {};

  const skills = additionalFields ? toArray(additionalFields?.skills, ",") : [];
  const profilePicUrl = imageUrl(
    additionalFields?.profile_picture,
    "customers"
  );

  const candidateDetailUrl = `/candidate/details/${details?.id}`;

  const jobLocations = useSelector((state) => state.jobLocations.data) || [];

  return (
    <Link to={candidateDetailUrl} className={"candidate-list-box card mb-4"}>
      <CardBody className='p-4'>
        <Row>
          <Col xl={12} lg={12}>
            <div className='d-lg-flex gap-4'>
              <div className='candidate-list-images'>
                <img
                  src={
                    additionalFields?.profile_picture
                      ? profilePicUrl
                      : userImage6
                  }
                  alt=''
                  className='avatar-md img-thumbnail rounded-circle'
                />
              </div>
              <div className='candidate-list-content mt-3 mt-lg-0 '>
                <h5 className='fs-19 mb-0'>
                  <span className='primary-link text-capitalize'>
                    {(details?.name || details?.username)?.trim()}
                  </span>

                  <div
                    className={`badge active-hours-badge  ${
                      isUserActive(details?.last_login_date)
                        ? "bg-soft-success"
                        : "bg-soft-secondary"
                    }`}
                  >
                    <span className='text-muted ms-1'>
                     Active {getTimeAgo(details?.last_login_date)}
                    </span>
                  </div>
                </h5>

                <p className='text-muted mb-1' style={{ marginLeft: 2 }}>
                  {additionalFields?.designation}
                </p>
                <ul className='list-inline mb-0 text-muted'>
                  <li className='list-inline-item me-3 mb-2'>
                    <i className='mdi mdi-map-marker'></i>{" "}
                    {getJobLocationById(
                      additionalFields?.location,
                      jobLocations
                    )}
                  </li>
                  {additionalFields?.total_work_experience && (
                    <li className='list-inline-item me-3 mb-2'>
                      <i className='uil uil-briefcase-alt'></i>{" "}
                      {getWorkExpText(additionalFields?.total_work_experience)}
                    </li>
                  )}
                  {additionalFields?.expected_salary_per_month && (
                    <li className='list-inline-item me-3 mb-2'>
                      {getSalaryAmount(
                        additionalFields?.expected_salary_per_month
                      )}
                    </li>
                  )}

                  {additionalFields?.job_type && (
                    <li className='list-inline-item me-3 mb-2'>
                      <i className='mdi mdi-briefcase-clock-outline'></i>{" "}
                      {additionalFields?.job_type}
                    </li>
                  )}
                </ul>

                {skills?.length > 0 && (
                  <div className='mb-3 mt-lg-0 d-flex flex-wrap align-items-start gap-1'>
                    {skills?.map((skill, key) => (
                      <span
                        className='badge bg-soft-dark fs-10 mt-1 text-wrap text-start text-break'
                        key={key}
                        style={{ lineHeight: 1.3, borderRadius: 30 }}
                      >
                        {skill}
                      </span>
                    ))}
                  </div>
                )}

                {/* <div className='d-flex me-lg-n2 mt-2 '>
                    <Button color='primary' size='sm'>
                      Hire Now
                    </Button>
                  </div> */}

                {/* <div className='d-flex justify-content-between align-items-center me-lg-n2 w-100'>
                  <p>{moment(details?.last_login_date)?.fromNow()}</p>
                  <Button color='primary' size='md'>
                    Hire Now
                  </Button>
                </div> */}
              </div>
            </div>
          </Col>

          {/* <Col xl={2} lg={2}>
              <div className="d-flex justify-content-lg-end me-lg-n2 mt-3 mt-lg-5 ">
                <Button color="primary" size="md">
                  Hire Now
                </Button>
              </div>
            </Col> */}
        </Row>

        <AddToBookmarkCandidate candidateId={details?.id} />
      </CardBody>
    </Link>
  );
};

export default CandidateRow;
